export default "__VITE_ASSET__pcgto21$__"